import React, { useEffect, useState } from "react"
import { Link, graphql } from "gatsby"
import { connect } from "react-redux"
import Styles from "./ProductTemplate.module.scss"
import SEO from "../seo"
import Carousel from "../Carousel/Carousel"
import AddToCart from "../Skus/AddToCart"
import { registerRecentView } from "../../database/dbActions"
import SaveForLater from "../Skus/SaveForLater"
import SizeDropdown from "../Skus/SizeDropdown"
import QuantityCounter from "../Skus/QuantityCounter"

const ProductTemplate = ({ data, uid, cart }) => {
  const {
    id,
    name,
    price,
    categories,
    images,
    sizes,
    shortDescription,
    fullDescription,
  } = data.contentfulProducts

  const [productInCart, productInCartUpdater] = useState(null)
  const [selectedSize, selectedSizeUpdater] = useState(null)
  const [quantity, quantityUpdater] = useState(1)

  useEffect(() => {
    if (uid) {
      registerRecentView(uid, id, images[0].fluid)

      cart.products.filter(product => {
        if (id === product.id) {
          return product
        }
      }).length === 0
        ? productInCartUpdater(false)
        : productInCartUpdater(true)
    }
  }, [uid, cart.products])

  return (
    <>
      <SEO title={name} description={shortDescription} />
      <section className={Styles.product}>
        <Carousel images={images} />
        <div className={Styles.productdetails}>
          <h1 className={Styles.name}>{name}</h1>
          <h3 className={Styles.price}>£ {price}</h3>
          <div className={Styles.categories}>
            {categories.map(category => (
              <span className={Styles.category} key={category.id}>
                <Link to={`/${category.name.toLowerCase()}`}>
                  {category.name}
                </Link>
              </span>
            ))}
          </div>
          {!productInCart ? (
            <div className={Styles.productoptions}>
              <SizeDropdown
                onSelectSize={size => {
                  selectedSizeUpdater(size)
                }} // a passed down function that returns the size selected
                sizes={sizes}
              />

              <QuantityCounter
                id={id}
                quantity={quantity}
                onSelectQuantity={(id, quantity) => quantityUpdater(quantity)}
              />
            </div>
          ) : null}

          <p className={Styles.shortdescription}>{shortDescription}</p>

          <AddToCart
            id={id}
            name={name}
            image={images[0]}
            price={price}
            size={selectedSize}
            sizes={sizes}
            quantity={quantity}
          />

          {uid ? (
            <SaveForLater
              id={id}
              name={name}
              image={images[0]}
              price={price}
              sizes={sizes}
            />
          ) : null}
        </div>

        <div
          className={Styles.fulldescription}
          dangerouslySetInnerHTML={{
            __html: fullDescription.childMarkdownRemark.html,
          }}
        />
      </section>
    </>
  )
}

export const query = graphql`
  query($sku: String!) {
    contentfulProducts(id: { eq: $sku }) {
      id
      name
      price
      shortDescription
      images {
        id
        fluid {
          ...GatsbyContentfulFluid
        }
        description
      }
      categories {
        id
        name
      }
      sizes {
        size
      }
      fullDescription {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`

const mapStateToProps = state => ({
  uid: state.auth.uid,
  cart: state.shoppingCart,
})
export default connect(mapStateToProps)(ProductTemplate)
